import { AUTH } from '../constants/AppConstants';
import * as AuthActions from '../actions/authActions';
import { store } from '../index';

/**
 * Instead of asking the backend whether we are authenticated every refresh etc.,
 * we store a Redux state attribute and check against that, removing on logout.
 */
export const setAuth = authStatus => store.dispatch(AuthActions.setAuth(authStatus));
export const removeAuth = () => store.dispatch(AuthActions.removeAuth());
export const hasAuth = authStatus => store.getState()[AUTH] === authStatus;
